import styled from 'styled-components';

const FieldRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FieldName = styled.div`
  min-width: 96px;
  width: 96px;
  max-width: 96px;
`;

export { FieldRow,
  FieldName };
